export default __webpack_public_path__ + "static/media/open-drip.e7f01203.png";